export default [
  {
    name: 'project_products_list',
    component_path: 'modules/templates/blocks/project/ProjectProductsList'
  }
]